import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const STORAGE_KEY = 'pv_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent" aria-live="polite">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <strong>We use cookies</strong> to improve your experience and analyze site traffic.
          By continuing to use our site, you agree to our use of cookies.{' '}
          <a href="/contact" className="cookie-banner__link">Learn more</a>
        </div>
        <div className="cookie-banner__actions">
          <button type="button" className="btn btn-outline cookie-decline" onClick={handleDecline}>
            Decline
          </button>
          <button type="button" className="btn btn-gold cookie-accept" onClick={handleAccept}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
